import { render, staticRenderFns } from "./contactWayFormModel.vue?vue&type=template&id=73e2e3fa&scoped=true"
import script from "./contactWayFormModel.vue?vue&type=script&lang=js"
export * from "./contactWayFormModel.vue?vue&type=script&lang=js"
import style0 from "./contactWayFormModel.vue?vue&type=style&index=0&id=73e2e3fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e2e3fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e2e3fa')) {
      api.createRecord('73e2e3fa', component.options)
    } else {
      api.reload('73e2e3fa', component.options)
    }
    module.hot.accept("./contactWayFormModel.vue?vue&type=template&id=73e2e3fa&scoped=true", function () {
      api.rerender('73e2e3fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/settings/components/contactWayFormModel.vue"
export default component.exports